var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 99,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 98.878,
    rx: 47,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.588 49.439l4.941 4.942 9.883-9.884m14.825 4.942a22.238 22.238 0 11-44.475 0 22.238 22.238 0 0144.475 0z",
    stroke: "#DC4017",
    strokeWidth: 4.942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/icon-check-circle.92f6e2ec.svg";
export { SvgIconCheckCircle as ReactComponent };